(function () {
  const categorySearches = [
    [['new', 'new in', 'new-in', 'new arrivals', 'restocks'], '/collections/new-in'],
    [['kids', 'kid', 'children', 'childrens', "children's", 'boys', 'boy', 'girls', 'girl', 'toddler', 'toddlers', 'youth', 'nino', 'ninos', 'nina', 'ninas'], '/pages/kids-outerwear'],
    [['parka', 'parkas', 'avalanche', 'pathfinder', 'winter coat', 'winter coats', 'winter jacket', 'winter jackets', 'snow coat', 'snow coats'], '/collections/parkas'],
    [['puffer', 'puffers', 'puffer jacket', 'puffer jackets', 'bubble jacket', 'bubble jackets', 'bubble coat', 'bubble coats', 'summit'], '/collections/puffers'],
    [['statement', 'statement outerwear', 'statement pieces', 'melton', 'bear', 'goat', 'g.o.a.t', 'embroidered', 'embroidery'], '/collections/statement-outerwear'],
    [['leather', 'faux leather', 'vegan leather', 'pleather', 'faux', 'nubuck', 'aviator', 'lucky voyager'], '/collections/faux-leather'],
    [['varsity', 'varsity jacket', 'varsity jackets', 'kumo'], '/collections/varsity'],
    [['workwear', 'utility', 'nexus'], '/collections/nexus'],
    [['winter', 'heavy winter', 'cold weather'], '/collections/parkas'],
    [['big tall', 'big and tall', 'big & tall', '2x', '2xl', '3x', '3xl', '4x', '4xl', '5x', '5xl', '6x', '6xl'], '/collections/big-and-tall'],
    [['shop all', 'outerwear', 'jacket', 'jackets'], '/collections/all']
  ];

  function normalizeSearch(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim()
      .replace(/\s+/g, ' ');
  }

  function categoryUrlFor(query) {
    const normalized = normalizeSearch(query);

    if (!normalized) return '';

    for (const [terms, url] of categorySearches) {
      const normalizedTerms = terms.map(normalizeSearch);
      if (normalizedTerms.includes(normalized)) {
        return url;
      }
    }

    for (const [terms, url] of categorySearches) {
      const normalizedTerms = terms.map(normalizeSearch).filter((term) => term.length > 3);
      if (normalizedTerms.some((term) => normalized.includes(term))) {
        return url;
      }
    }

    return '';
  }

  function ensureProductOnlySearchForms() {
    document.querySelectorAll('form[action*="/search"]').forEach((form) => {
      if (!(form instanceof HTMLFormElement) || form.dataset.awakndlandSearchTidied === 'true') return;

      const typeInput = form.querySelector('input[name="type"]') || document.createElement('input');
      typeInput.type = 'hidden';
      typeInput.name = 'type';
      typeInput.value = 'product';

      if (!typeInput.parentElement) {
        form.appendChild(typeInput);
      }

      const prefixInput = form.querySelector('input[name="options[prefix]"]') || document.createElement('input');
      prefixInput.type = 'hidden';
      prefixInput.name = 'options[prefix]';
      prefixInput.value = 'last';

      if (!prefixInput.parentElement) {
        form.appendChild(prefixInput);
      }

      form.dataset.awakndlandSearchTidied = 'true';
    });
  }

  function handleSearchForm(form, event) {
    if (!form || !(form instanceof HTMLFormElement)) return false;

    const action = form.getAttribute('action') || '';

    if (!action.includes('/search')) return false;

    const searchInput = form.querySelector('input[name="q"]');
    const categoryUrl = categoryUrlFor(searchInput ? searchInput.value : '');

    if (!categoryUrl) return false;

    event.preventDefault();
    event.stopPropagation();
    window.location.assign(categoryUrl);

    return true;
  }

  document.addEventListener(
    'submit',
    function (event) {
      handleSearchForm(event.target, event);
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      const button = event.target && event.target.closest ? event.target.closest('button[type="submit"]') : null;
      const form = button ? button.closest('form[action*="/search"]') : null;

      handleSearchForm(form, event);
    },
    true
  );

  document.addEventListener(
    'keydown',
    function (event) {
      if (event.key !== 'Enter') return;

      const input = event.target && event.target.closest ? event.target.closest('input[name="q"]') : null;
      const form = input ? input.closest('form[action*="/search"]') : null;

      handleSearchForm(form, event);
    },
    true
  );

  function redirectExistingSearchPage() {
    const pathname = window.location.pathname.replace(/\/+$/, '');

    if (pathname === '/collections') {
      window.location.replace('/collections/all');
      return;
    }

    if (pathname !== '/search') return;

    const params = new URLSearchParams(window.location.search);
    const categoryUrl = categoryUrlFor(params.get('q') || '');

    if (categoryUrl) {
      window.location.replace(categoryUrl);
    }
  }

  function tidyVisibleProductTitles() {
    document
      .querySelectorAll(
        '.template-product h1, .awakndland-product-card__title, .card-title, .view-product-title'
      )
      .forEach((node) => {
        if (!node || node.dataset.awakndlandTitleTidied === 'true') return;

        const cleaned = node.textContent.replace(/[“”]/g, '').replace(/\s+/g, ' ').trim();
        if (cleaned && cleaned !== node.textContent.trim()) {
          node.textContent = cleaned;
        }

        node.dataset.awakndlandTitleTidied = 'true';
      });
  }

  redirectExistingSearchPage();
  ensureProductOnlySearchForms();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      ensureProductOnlySearchForms();
      tidyVisibleProductTitles();
    });
  } else {
    tidyVisibleProductTitles();
  }

  document.addEventListener('shopify:section:load', function () {
    ensureProductOnlySearchForms();
    tidyVisibleProductTitles();
  });
})();
